import React, { Component } from 'react'
import styled from 'styled-components'

export default styled.div`
padding: 32px;
`



// WEBPACK FOOTER //
// ./src/components/componentWrapper/index.jsx